import type { Object3D, Vector3 } from '@anov/3d-core'
import { Color, ExtrudeGeometry, Mesh, MeshBasicMaterial, Shape, Vector2 } from '@anov/3d-core'
import * as THREE from '@anov/3d-core'
import type { FillAreaOption } from '../type'
import { RoundLineGeometry, createRoundedClosedCurve } from '../../Utils/round-curve'
import FillAreaBase from './FillAreaBase'

class FillArea_Face_01 extends FillAreaBase {
  constructor(option: FillAreaOption, areaInstance: Object3D) {
    super(option, areaInstance)
    this.create()
  }

  create() {
    this._mesh = this.createMesh(this._points, this._color, this._alpha)
    this._mesh && this.add(this._mesh)
  }

  createMesh(points: Vector3[], color: string, alpha: number) {
    if (!points)
      return

    // 创建材质
    const material = new MeshBasicMaterial({ color: new Color(color), transparent: true, opacity: alpha, side: 2 })
    // // 创建一个Shape对象，用于定义填充区域的平面形状
    // const shape = new Shape()
    // // 将第一个点的x、z坐标作为Shape的起始位置
    // shape.moveTo(points[0].x, points[0].z)

    // // 遍历剩余的点，依次将它们的x、z坐标连接起来，构成封闭的平面形状
    // for (let i = 1; i < points.length; i++)
    //   shape.lineTo(points[i].x, points[i].z)
    // // 闭合形状路径，确保形状是封闭的，以便后续挤出操作生成正确的几何体
    // shape.closePath()
    // const roundLineGeometry = new RoundLineGeometry(points, { radius: this._corner, close: this._close })
    // const curve = roundLineGeometry.curve
    const curvePath = createRoundedClosedCurve(points, this._corner, this._close)
    const pathPoints = curvePath.getPoints(1000)
    // const currentPoints = curve.getPoints(1000)
    const points2D = pathPoints.map((p: any) => new Vector2(p.x, p.z))
    // 创建一个Shape并添加封闭路径
    const shape = new Shape(points2D)
    // 定义挤出几何体的基本设置，包括步数、是否启用斜角、挤出深度以及挤出路径等
    const extrudeSettings = {
      steps: 100,
      bevelEnabled: false,
      depth: 1,
      extrudePath: undefined,
    }

    // 生成填充区域的几何体
    const geometry = new ExtrudeGeometry(shape, extrudeSettings)
    // 生成填充区域的网格物体
    const mesh = new Mesh(geometry, material)
    // 将填充区域的网格物体绕x轴旋转90度
    mesh.rotateX(Math.PI / 2)

    return mesh
  }

  // Getter and Setter for fenceColor property
  // get color(): string {
  //   return this._color
  // }

  // set color(newValue: string) {
  //   if (this._color === newValue)
  //     return

  //   this._color = newValue
  //   if (this.mesh)
  //     (this.mesh.material as MeshBasicMaterial).color = new Color(newValue)
  // }

  // // Getter and Setter for fenceAlpha property
  // get alpha(): number {
  //   return this._alpha
  // }

  // set alpha(newValue: number) {
  //   if (this._alpha === newValue)
  //     return

  //   this._alpha = newValue
  //   if (this.mesh)
  //     (this.mesh.material as MeshBasicMaterial).opacity = newValue
  // }
}

export default FillArea_Face_01